/**
 * Convert a server descriptor into the exact immutable selection contract.
 * No hash or version is guessed client-side. date_of_change: 2026-08-21
 */
export const builtinRulesetSelection = (ruleset) => ({
  mode: 'builtin',
  presetId: ruleset.presetId,
  versionId: ruleset.rulesetVersionId,
  definitionHash: ruleset.definitionHash
});

export const storedRulesetSelection = (ruleset) => ({
  mode: 'stored',
  packageId: ruleset.packageId,
  versionId: ruleset.rulesetVersionId,
  definitionHash: ruleset.definitionHash
});

export const copyRulesetSelection = (selection) => ({ ...selection });

export const fetchDefaultBuiltinRulesetSelection = async (apiFetch) => {
  const response = await apiFetch('/api/ruleset/presets', { method: 'GET', requireAuth: true });
  if (!response.ok) throw new Error(`Built-in rulesets could not be loaded (${response.status}).`);
  const presets = await response.json();
  const selected = (Array.isArray(presets) ? presets : []).find((ruleset) => ruleset.presetId === 'vcs-core-5e-2014');
  if (!selected) throw new Error('The VCS Core 5e (2014) ruleset is not registered.');
  return builtinRulesetSelection(selected);
};
